module.exports = __webpack_public_path__ + "static/pink_sapphire-b664c1d5dc7d023807c6dea903c495d3.svg";